<h1 mat-dialog-title>{{ data.title ? data.title : 'Bestätigen'}}</h1>
<div mat-dialog-content>
  <p>{{ data.content ? data.content : 'Sind Sie sicher?' }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">{{ data.cancel ? data.cancel : 'Abbrechen' }}</button>
  <button mat-button (click)="confirm()" color="primary" cdkFocusInitial>{{ data.confirm ? data.confirm : 'Bestätigen' }}</button>
</div>
